import url from './url';



export default url(({ categoryId = ':categoryId' }) => `/categories/${categoryId}/view`);
